import Link from 'next/link'

type PropsType = {
  href?: string | null
  title?: string
  external?: boolean
}

const ContentDetailLink = ({ href, title, external = false }: PropsType) => {
  if (!href) {
    return null
  }

  return (
    <Link
      href={href}
      target={external ? '_blank' : undefined}
      rel={external ? 'noopener noreferrer' : undefined}
      className="text-gray-600 hover:text-gray-800 hover:underline">
      {title ?? href}
    </Link>
  )
}

export default ContentDetailLink
